import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const UserLogsCollection = GenericCollectionFactory(GENERIC_IDS.USER_LOGS);